<template>
  <div id="container" class="store_st_list">
    <!-- Location START -->
    <div class="location_wrap">
      <div class="location">
        <span>{{ $t('views.store.enotes.1820') }}</span>
        <span class="svg_next">></span>
        <div class="current">
          <div class="select_area">
            <div class="select_item">
              <button type="button" class="select_option">
                <span class="txt">{{ $t('views.store.enotes.e') }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- FIXME: @Tim This is only used on the store/categories page. Need to discuss with planning team since this UI seems strange -->
        <!-- <span class="svg_next">></span>
        <div class="current">
          <div class="select_area">
            <div class="select_item">
              <button type="button" class="select_option">
                <span class="txt"> 전체 </span
                ><span class="arrow blind">열기</span>
              </button>
              <ul class="select_list">
                <li v-for="(link, idx) in schoolLinks" :key="idx">
                  <router-link
                    :to="{ name: 'books_category', params: { id: 1 } }"
                    >{{ link.title }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- Location END -->

    <div class="section pb">
      <div class="inner">
        <h2>
          <span class="sec_title">{{ $t('views.store.enotes.e1') }}</span>
        </h2>
        <div
          class="eplist item_columns_grid"
          :class="[landscape ? 'item_landscape' : 'item_image']"
        >
          <!-- 리스트 호출 : 펼쳐보기(페이지당 10개), min - 간략보기(페이지당 36개) -->
          <div class="eplist_listype">
            <button
              type="button"
              class="btn_listype_min"
              :class="{ active: !landscape }"
              @click="normalMode"
            >
              <svg viewBox="0 0 18 18" class="svg_listype">
                <path
                  d="M17 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0ZM8 16H2V10H8V16ZM8 8H2V2H8V8ZM16 16H10V10H16V16ZM16 8H10V2H16V8Z"
                ></path>
              </svg>
              <span class="blind">{{ $t('views.store.enotes.1329') }}</span>
            </button>
            <button
              type="button"
              :class="{ active: landscape }"
              class="btn_listype_max"
              @click="landscapeMode"
            >
              <svg viewBox="0 0 16 12" class="svg_listype">
                <path
                  d="M1 2H15C15.2652 2 15.5196 1.89464 15.7071 1.70711C15.8946 1.51957 16 1.26522 16 1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM15 5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7H15C15.2652 7 15.5196 6.89464 15.7071 6.70711C15.8946 6.51957 16 6.26522 16 6C16 5.73478 15.8946 5.48043 15.7071 5.29289C15.5196 5.10536 15.2652 5 15 5ZM15 10H1C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10Z"
                ></path>
              </svg>
              <span class="blind">{{ $t('views.store.enotes.5315') }}</span>
            </button>
          </div>

          <div class="eplist_sort">
            <ul class="board_sort">
              <li v-for="sort in sortOrder" :key="sort.value">
                <a
                  tabindex="0"
                  :class="[currentSortValue === sort.value ? 'active' : '']"
                  @click="changeSortOrder(sort)"
                  @keypress.enter="changeSortOrder(sort)"
                >
                  <span>{{ sort.text }}</span>
                </a>
              </li>
            </ul>
          </div>

          <ul v-if="!isStoreEnotesLoading && getStoreEnotes" class="item_list">
            <!-- NOTE: @Stan I know this could be an object to simplify, 
            but I'm using v-ifs within BaseBook and only passing what 
            is needed based on specific UI's within the app to show/hide 
            parts of it dynamically. Not the way I would like to do it, 
            but this seemed simplest based on the multiple versions of 
            BaseBook that the design called for  -->
            <BaseBook
              v-for="(book, idx) in getStoreEnotes"
              :key="idx"
              :book="book"
              :landscape="landscape"
            />
          </ul>

          <Pagination
            :current-page="currentPage"
            :total-count="getStoreEnotesTotalCount"
            :item-per-page="booksPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
    </div>

    <HelpDesk />
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'

import { mapGetters } from 'vuex'

import { STORE_ENOTE_GET_LIST } from '@/store/types'

export default {
  name: 'Enotes',
  components: {
    HelpDesk
  },
  data() {
    return {
      landscape: true,
      currentPage: 1,
      booksPerPage: 10,
      currentSortValue: 'PL',
      sortOrder: [
        {
          value: 'PL',
          text: '인기순'
        },
        {
          value: 'PD',
          text: '출간일'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'isStoreEnotesLoading',
      'getStoreEnotes',
      'getStoreEnotesTotalCount'
    ])
  },
  mounted() {
    if (!this.getStoreEnotes) {
      this.$store.dispatch(STORE_ENOTE_GET_LIST, {
        sort: this.currentSortValue
      })
    }
  },
  methods: {
    normalMode() {
      this.landscape = false
    },
    landscapeMode() {
      this.landscape = true
    },
    changeSortOrder(sort) {
      this.currentSortValue = sort.value
      this.currentPage = 1
      this.$store.dispatch(STORE_ENOTE_GET_LIST, {
        sort: sort.value
      })
    },
    paginate(page) {
      this.currentPage = page
      this.$store.dispatch(STORE_ENOTE_GET_LIST, {
        sort: this.currentSortValue,
        page: this.currentPage
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
